// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-brands-brand-item-item-bwmcu{transition:all .1s ease-in-out;background:var(--color-grayLight);border-radius:12px;display:block;overflow:hidden;padding:12px}.components-brands-brand-item-item-bwmcu:hover{background:var(--color-grayLight-hover);box-shadow:0 3px 8px 0 rgba(0,0,0,.12)}.components-brands-brand-item-image-fiyod{display:block;line-height:0;overflow:hidden;padding-top:56.25%;position:relative}.components-brands-brand-item-imageInner-bdnon{transition:all .1s ease-in-out;right:0;top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"item": "components-brands-brand-item-item-bwmcu",
	"image": "components-brands-brand-item-image-fiyod",
	"imageInner": "components-brands-brand-item-imageInner-bdnon"
};
module.exports = ___CSS_LOADER_EXPORT___;
